import Link from 'next/link';
import { m } from 'motion/react';
import { twMerge } from 'tailwind-merge';
import { MenuLinks } from './menu-links';
import { SocialLinks } from '../social-links/social-links';
import { Button } from '../ui/button/button';

export const MobileMenu = ({ isOpened }: { isOpened: boolean }) => {
  return (
    <div
      className={twMerge(
        'fixed inset-0 z-40 transition-opacity duration-500 ease-out',
        isOpened && 'bg-[rgba(24,24,24,0.97)] opacity-100'
      )}
    >
      <m.nav
        initial={{ translateY: '-25px', opacity: 0 }}
        animate={{ translateY: '0', opacity: 1 }}
        className="relative px-8 pt-32 pb-24 flex flex-col items-stretch gap-8 text-3xl text-foreground lg:text-base"
      >
        <MenuLinks className="mt-0 px-0 text-xl gap-5 tracking-[0.25em]" />
        <Button as={Link} href="/kontakt" className="shadow-lg w-full justify-center text-base" variant="primary">
          Napisz do nas!
        </Button>
      </m.nav>
      <m.div
        initial={{ opacity: 0, translateY: '30px', translateX: '-50%' }}
        animate={{ opacity: 1, translateY: '0', translateX: '-50%' }}
        transition={{ delay: 0.25 }}
        className="absolute left-1/2 bottom-8 w-4/5"
      >
        <p className="text-foreground/70 text-center mb-4 text-xs uppercase tracking-[0.5em]">Sprawdź nas na:</p>
        <SocialLinks variant="contrast" iconColor="light" />
      </m.div>
    </div>
  );
};
